module.exports = __webpack_public_path__ + "static/img/l_muke.9dcdf852.png";